import { Llamada } from "./Llamada";
import { PeticionWeb } from "./PeticionWeb";
import { Vehiculo } from "./Vehiculo";
import {HojasCallCenterComponent} from "../hojas-call-center.component";
import {DetallePetcicion} from "../GestionPeticiones/detalle-peticion/DetallePetcicion";
import {PilotosFunctions} from "../functionDefinitions/Pilotos";

export class DatoDetallePeticion
{
    fechaPet:Date = new Date();
    cliente:string = "";
    telefono:string = "";


    cia:string = "";
    email:string = "";
    siniestro:string = "";
    servicio:string = "";
    /*matricula:string = "";
    marca:string = "";
    modelo:string = "";
    */
    taller:string = "";
    //puertas:number = 0;
    vehiculo:Vehiculo = new Vehiculo();
    llamada :Llamada=new Llamada();

    //devuelve un nuevo DatoDetallePeticion a partir de los datos del detalle
    public static convertirPeticionSegu(pWeb:DetallePetcicion, hojaprin: HojasCallCenterComponent)
    {
      hojaprin.onEntradaLlamadaSelected("100000032", pWeb.taller.toString().padStart(3, '0'));
      hojaprin.llamada.recomendado = "B";
      hojaprin.llamada.origen = "01";
      hojaprin.idgestionweb = pWeb.id.toString().trim();
      hojaprin.asegurado.nombre = pWeb.cia.toString().trim();
      hojaprin.asegurado.tel1 = pWeb.tel.toString().trim();
      hojaprin.asegurado.siniestro = pWeb.siniestro.toString().trim();
      hojaprin.showObtenerSiniestro = false;
      hojaprin.mensajeObser = pWeb.observaciones.toString().trim();
      hojaprin.vehiculo.matricula = pWeb.matricula.toString().trim();
      hojaprin.asegurado.poliza = pWeb.poliza.toString().trim();
      hojaprin.llamada.tipo = "100";
      hojaprin.habGestionVarias = true;
      this.fechaReal(hojaprin, pWeb.fecha.toString().trim());
    }

  public static convertirPeticionWebElse(pWeb:DetallePetcicion, hojaprin: HojasCallCenterComponent)
  {
    switch(pWeb.tipo){
      case "Formularios Contacto":
        hojaprin.onEntradaLlamadaSelected("200000106");
        break;
      case "Formulario Campañas":
        hojaprin.onEntradaLlamadaSelected("");
        break;
      case "Formularios Servicios":
        hojaprin.onEntradaLlamadaSelected("200000106");
        break;
      case "Formulario Te Llamamos":
        hojaprin.onEntradaLlamadaSelected("100000050");
        break;
      case "CHATBOT":
        hojaprin.onEntradaLlamadaSelected("100000050");
        break;
    }

    switch(pWeb.id_piloto.toString().trim()){
      case "1":
      case "2":
      case "11":
      case "12":
      case "13":
        hojaprin.onEntradaLlamadaSelected("100000049");
        break;
      case "3":
        hojaprin.onEntradaLlamadaSelected("100000052");
        break;
      case "4":
        hojaprin.onEntradaLlamadaSelected("200000059");
        break;
      case "5":
        hojaprin.onEntradaLlamadaSelected("200000061");
        break;
      case "6":
        hojaprin.onEntradaLlamadaSelected("100000057");
        break;
      case "7":
        hojaprin.onEntradaLlamadaSelected("200000063");
        break;
      case "8":
        hojaprin.onEntradaLlamadaSelected("200000064");
        break;
      case "9":
        hojaprin.onEntradaLlamadaSelected("200000060");
        break;
      case "10":
        hojaprin.onEntradaLlamadaSelected("200000062");
        break;
    }

    hojaprin.idgestionweb = pWeb.id.toString().trim();
    hojaprin.asegurado.nombre = pWeb.cia.toString().trim();
    hojaprin.asegurado.tel1 = pWeb.tel.toString().trim();
    hojaprin.vehiculo.marca = pWeb.marca.toString().trim();
    hojaprin.vehiculo.modelo = pWeb.modelo.toString().trim();
    hojaprin.asegurado.email = pWeb.email.toString().trim();
    hojaprin.mensajeObser = pWeb.observaciones.toString().trim();
    hojaprin.asegurado.siniestro = pWeb.siniestro.toString().trim();
    hojaprin.vehiculo.matricula = pWeb.matricula.toString().trim();
    hojaprin.asegurado.nombre = pWeb.titular.toString().trim();
    this.fechaReal(hojaprin, pWeb.fecha.toString().trim());
  }

  public static convertirPeticionWebNew(pWeb:DetallePetcicion, hojaprin: HojasCallCenterComponent){
    if (pWeb.ia == "repair"){
      PilotosFunctions.addArticulo(hojaprin,"99000001", "REPARACION PARAB. 1 IMPACTO");
      hojaprin.mensajeObser = " [IA Indica Reparación] ";
    }else if(pWeb.ia == "change"){
      hojaprin.mensajeObser = " [IA Indica Substitución] ";
    }

    hojaprin.onEntradaLlamadaSelected("100000049", pWeb.taller.toString().padStart(3, '0'));
    hojaprin.llamada.recomendado = "C";
    hojaprin.llamada.tipo = "100";
    hojaprin.idgestionweb = pWeb.id.toString().trim();
    hojaprin.asegurado.nombre = pWeb.cia.toString().trim();
    hojaprin.asegurado.tel1 = pWeb.tel.toString().trim();
    hojaprin.fillExternaMarca(pWeb.marca.toString().trim(), pWeb.modelo.toString().trim());
    hojaprin.asegurado.email = pWeb.email.toString().trim();
    hojaprin.mensajeObser = hojaprin.mensajeObser.toString().trim() + " " + pWeb.observaciones.toString().trim();
    hojaprin.vehiculo.matricula = pWeb.matricula.toString().trim();
    hojaprin.asegurado.siniestro = pWeb.siniestro.toString().trim();
    hojaprin.asegurado.nombre = pWeb.titular.toString().trim();
    hojaprin.llamada.origen = "01";
    if (pWeb.cia == "OTROS" || pWeb.cia == "NO TENGO SEGURO"){
      hojaprin.auxCia = "CONTADOS";
    }
    this.fechaReal(hojaprin, pWeb.fecha);
  }
  public static convertirPeticionWeb(pWeb:DetallePetcicion, hojaprin: HojasCallCenterComponent){
    if(pWeb.tipo == "mapfreservicios"){
        hojaprin.onEntradaLlamadaSelected("200000049", pWeb.taller.toString().padStart(3, '0'));
    }
    hojaprin.idgestionweb = pWeb.id.toString().trim();
    hojaprin.asegurado.nombre = pWeb.cia.toString().trim();
    hojaprin.asegurado.tel1 = pWeb.tel.toString().trim();
    /*hojaprin.vehiculo.marca = pWeb.marca;
    hojaprin.vehiculo.modelo = pWeb.modelo;*/
    hojaprin.fillExternaMarca(pWeb.marca.toString().trim(), pWeb.modelo.toString().trim());
    hojaprin.mensajeObser = pWeb.observaciones.toString().trim();
    hojaprin.vehiculo.matricula = pWeb.matricula.toString().trim();
    hojaprin.asegurado.siniestro = pWeb.siniestro.toString().trim();
    hojaprin.asegurado.nombre = pWeb.titular.toString().trim();
    hojaprin.habGestionVarias = true;
    this.fechaReal(hojaprin, pWeb.fecha.toString().trim());
  }

  public static convertirPeticionRauda(pWeb:DetallePetcicion, hojaprin: HojasCallCenterComponent){
    hojaprin.onEntradaLlamadaSelected(hojaprin.llamada.entrada, pWeb.taller.toString().padStart(3, '0'));

    hojaprin.idgestionweb = pWeb.id.toString().trim();
    hojaprin.asegurado.nombre = pWeb.cia.toString().trim();
    hojaprin.asegurado.tel1 = pWeb.tel.toString().trim();
    hojaprin.fillExternaMarca(pWeb.marca.toString().trim(), pWeb.modelo.toString().trim());
    hojaprin.asegurado.email = pWeb.email.toString().trim();
    hojaprin.mensajeObser = hojaprin.mensajeObser.toString().trim() + ". Taller: " + pWeb.taller.toString().padStart(3, '0') + " " + pWeb.observaciones.toString().trim();
    hojaprin.vehiculo.matricula = pWeb.matricula.toString().trim();
    hojaprin.asegurado.siniestro = pWeb.siniestro.toString().trim();
    hojaprin.asegurado.nombre = pWeb.titular.toString().trim();

  }

  public static convertirPeticionOut(pWeb:DetallePetcicion, hojaprin: HojasCallCenterComponent)
  {
    hojaprin.onEntradaLlamadaSelected("200000100", pWeb.taller.toString().padStart(3, '0'));
    hojaprin.llamada.origen = "02";
    hojaprin.asegurado.nombre = pWeb.cia.toString().trim();
    hojaprin.asegurado.tel1 = pWeb.tel.toString().trim();
    hojaprin.asegurado.siniestro = pWeb.siniestro.toString().trim();
    hojaprin.fillExternaMarca(pWeb.marca.toString().trim(), pWeb.modelo.toString().trim());
    hojaprin.asegurado.email = pWeb.email.toString().trim();
    hojaprin.mensajeObser = pWeb.observaciones.toString().trim();
    hojaprin.asegurado.nombre = pWeb.titular.toString().trim();
    hojaprin.vehiculo.matricula = pWeb.matricula.toString().trim();
    hojaprin.habGestionVarias = true;
    this.fechaReal(hojaprin, pWeb.fecha.toString().trim());
  }

  public static convertirCoris(pWeb:DetallePetcicion, hojaprin: HojasCallCenterComponent){
    if (pWeb.taller != null && pWeb.taller != undefined){
      hojaprin.onEntradaLlamadaSelected("200000048", pWeb.taller.toString().padStart(3, '0'));
    }else{
      hojaprin.onEntradaLlamadaSelected("200000048");
    }
    hojaprin.llamada.origen = "01";
    hojaprin.llamada.tipo = "100";
    //hojaprin.auxCia = pWeb.cia.toString().trim();
    hojaprin.asegurado.nombre = pWeb.titular.toString().trim();
    hojaprin.asegurado.tel1 = pWeb.tel.toString().trim();
    hojaprin.asegurado.dirCliente = pWeb.provincia.toString().trim();
    hojaprin.fillExternaMarca(pWeb.marca.toString().trim(), pWeb.modelo.toString().trim());
    hojaprin.asegurado.email = pWeb.email.toString().trim();
    hojaprin.mensajeObser = pWeb.observaciones.toString().trim();
    hojaprin.vehiculo.matricula = pWeb.matricula.toString().trim();
    hojaprin.habGestionVarias = true;
    this.fechaReal(hojaprin, pWeb.fecha.toString().trim());
  }

  public static convertirUrquibas(pWeb:DetallePetcicion, hojaprin: HojasCallCenterComponent){
    if (pWeb.taller != null && pWeb.taller != undefined){
      hojaprin.onEntradaLlamadaSelected("200000055", pWeb.taller.toString().padStart(3, '0'));
    }else{
      hojaprin.onEntradaLlamadaSelected("200000055");
    }
    hojaprin.llamada.origen = "01";
    hojaprin.llamada.tipo = "100";
    //hojaprin.auxCia = pWeb.cia.toString().trim();
    hojaprin.asegurado.nombre = pWeb.titular.toString().trim();
    hojaprin.asegurado.tel1 = pWeb.tel.toString().trim();
    hojaprin.asegurado.dirCliente = pWeb.provincia.toString().trim();
    hojaprin.fillExternaMarca(pWeb.marca.toString().trim(), pWeb.modelo.toString().trim());
    hojaprin.asegurado.email = pWeb.email.toString().trim();
    hojaprin.mensajeObser = pWeb.observaciones.toString().trim();
    hojaprin.vehiculo.matricula = pWeb.matricula.toString().trim();
    hojaprin.habGestionVarias = true;
    this.fechaReal(hojaprin, pWeb.fecha.toString().trim());
  }

  public static convertirReparabrisas(pWeb:DetallePetcicion, hojaprin: HojasCallCenterComponent){
    if (pWeb.taller != null && pWeb.taller != undefined){
      hojaprin.onEntradaLlamadaSelected("100000058", pWeb.taller.toString().padStart(3, '0'));
    }else{
      hojaprin.onEntradaLlamadaSelected("100000058");
    }
    hojaprin.llamada.origen = "01";
    hojaprin.llamada.tipo = "100";
    //hojaprin.auxCia = pWeb.cia.toString().trim();
    hojaprin.idcorredor = pWeb.id.toString();
    hojaprin.asegurado.nombre = pWeb.titular.toString().trim();
    hojaprin.asegurado.agente = pWeb.agente.toString().trim();
    hojaprin.asegurado.tel1 = pWeb.tel.toString().trim();
    hojaprin.asegurado.dirCliente = pWeb.provincia.toString().trim();
    hojaprin.fillExternaMarca(pWeb.marca.toString().trim(), pWeb.modelo.toString().trim());
    hojaprin.asegurado.email = pWeb.email.toString().trim();
    hojaprin.mensajeObser = pWeb.observaciones.toString().trim();
    hojaprin.vehiculo.matricula = pWeb.matricula.toString().trim();
    hojaprin.habGestionVarias = true;
    hojaprin.idIncid = pWeb.id.toString().trim();
    this.fechaReal(hojaprin, pWeb.fecha.toString().trim());
  }

  public static fechaReal(hojaprin: HojasCallCenterComponent, fecha:string){
    let fechaPorDefecto = new Date(fecha);
    let mes = fechaPorDefecto.getMonth() + 1;
    let dia = fechaPorDefecto.getDate();
    let ano = fechaPorDefecto.getFullYear();
    hojaprin.asegurado.fecSin = `${ano}-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`;
  }
}

